import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ValidateApp } from '@src/common/ValidateApp';
import { FeedbackTab } from '@src/common/FeedbackTab';
import { OverlayProvider } from '@uhg-abyss/web/ui/OverlayProvider';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';
import { Header } from './Header';
import { CollapsingHeader } from './CollapsingHeader/CollapsingHeader';
import { PayerSelectDrawerWidget } from './Header/LogoActionBar/PayerSelectDrawer/PayerSelectDrawerWidget';
import { ProviderSelectDrawerWidget } from './Header/LogoActionBar/ProviderSelectDrawer/ProviderSelectDrawerWidget';
import { useProvider } from '@src/state/provider';
import { useHeaderMenu } from '@src/state/headerMenu';
import { usePayer } from '@src/state/payer';

export const Home = ({ setDigitalSecurityError }) => {
  // PPC EPV and UHCP Forms use different headers that are within their products.
  const location = useLocation();
  const pathname = location.pathname;
  const isUhcpForms = pathname.includes('uhcp-forms');
  const isCodeLookup = pathname.includes('code-lookup');
  const app = pathname.split('/')[2];
  const [providerNotSaved, setProviderNotSaved] = useState(false);

  const { payer } = usePayer.state();
  const { setPayer } = usePayer.actions();
  const { isPayerOpen, isProviderOpen } = useHeaderMenu.state();
  const { togglePayer, toggleProvider } = useHeaderMenu.actions();

  const { provider } = useProvider.state();
  const { setProvider } = useProvider.actions();
  return (
    <React.Fragment>
      <ValidateApp app='seamless.read'>
        <If condition={app !== 'epv' && !isUhcpForms && !isCodeLookup}>
          <OverlayProvider>
            <Choose>
              <When condition={getFeature('LEGACY_PAGEHEADER')}>
                <Header
                  setDigitalSecurityError={setDigitalSecurityError}
                  providerNotSaved={providerNotSaved}
                />
              </When>
              <Otherwise>
                <CollapsingHeader
                  setDigitalSecurityError={setDigitalSecurityError}
                />
              </Otherwise>
            </Choose>
          </OverlayProvider>
        </If>
        <If condition={getFeature('PAYER_SELECT_REDESIGN')}>
          <PayerSelectDrawerWidget
            payer={payer}
            setPayer={setPayer}
            isPayerOpen={isPayerOpen}
            togglePayer={togglePayer}
          />
        </If>
        <If condition={getFeature('PROVIDER_SELECT_REDESIGN')}>
          <ProviderSelectDrawerWidget
            provider={provider}
            setProvider={setProvider}
            isProviderOpen={isProviderOpen}
            setProviderNotSaved={setProviderNotSaved}
            toggleProvider={toggleProvider}
            setDigitalSecurityError={setDigitalSecurityError}
          />
        </If>
        <FeedbackTab />
      </ValidateApp>
    </React.Fragment>
  );
};
